module.exports = __webpack_public_path__ + "img/2-3.1f25598b.jpg";